// third party
import { merge } from "lodash-es";

// project imports
import AppBar from "./AppBar";
import Button from "./Button";
import Card from "./Card";
import CardActions from "./CardActions";
import CardContent from "./CardContent";
import CardHeader from "./CardHeader";
import Checkbox from "./Checkbox";
import Chip from "./Chip";
import CssBaseline from "./CssBaseline";
import DataGrid from "./DataGrid";
import Dialog from "./Dialog";
import Divider from "./Divider";
import Drawer from "./Drawer";
import IconButton from "./IconButton";
import InputBase from "./InputBase";
import List from "./List";
import ListItemButton from "./ListItemButton";
import Menu from "./Menu";
import OutlinedInput from "./OutlinedInput";
import Paper from "./Paper";
import Slider from "./Slider";
import SvgIcon from "./SvgIcon";
import TableCell from "./TableCell";
import Tabs from "./Tabs";
import Tooltip from "./Tooltip";
import Typography from "./Typography";

// ===============================||  OVERRIDES - MAIN  ||=============================== //

export default function ComponentsOverrides(theme, borderRadius, outlinedFilled) {
  return merge(
    AppBar(theme),
    Button(theme),
    Card(theme),
    CardActions(),
    CardContent(),
    CardHeader(theme),
    Checkbox(),
    Chip(theme),
    CssBaseline(theme),
    DataGrid(theme),
    Dialog(),
    Divider(theme),
    Drawer(theme),
    IconButton(theme),
    InputBase(theme),
    List(theme),
    ListItemButton(theme),
    Menu(theme),
    OutlinedInput(theme, borderRadius, outlinedFilled),
    Paper(borderRadius),
    Slider(theme),
    SvgIcon(theme),
    TableCell(theme),
    Tabs(theme),
    Tooltip(theme),
    Typography(theme)
  );
}